import React, { useState, useEffect } from 'react';
import { Bell, BellOff, Check } from 'lucide-react';

const MOTIVATIONAL = [
  'כל יום נקי הוא ניצחון! 💪',
  'אתה חזק יותר ממה שאתה חושב 🌟',
  'היום הוא הזדמנות חדשה ✨',
  'אתה לא לבד בדרך הזו 💙',
  'כל צעד קדימה הוא התקדמות 🚀',
  'הרצף שלך מדהים - המשך! 🔥',
  'גאה בך על כל יום נקי! 🏆',
];

const Notifications = () => {
  const [permission, setPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  );
  const [reminderTime, setReminderTime] = useState('09:00');
  const [enabled, setEnabled] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('notif_time');
    const savedEnabled = localStorage.getItem('notif_enabled');
    if (saved) setReminderTime(saved);
    if (savedEnabled === 'true') setEnabled(true);
  }, []);

  const requestPermission = async () => {
    if (typeof Notification === 'undefined') return;
    const result = await Notification.requestPermission();
    setPermission(result);
    if (result === 'granted') {
      setEnabled(true);
      new Notification('יומן גמילה 💙', {
        body: 'התראות הופעלו! נשלח לך תזכורת כל יום.',
        icon: '/icons/icon-192x192.png',
      });
    }
  };

  const saveSettings = () => {
    localStorage.setItem('notif_time', reminderTime);
    localStorage.setItem('notif_enabled', String(enabled));
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);

    // Schedule a test notification
    if (permission === 'granted' && enabled) {
      setTimeout(() => {
        const quote = MOTIVATIONAL[Math.floor(Math.random() * MOTIVATIONAL.length)];
        new Notification('יומן גמילה - תזכורת יומית 🌟', {
          body: quote,
          icon: '/icons/icon-192x192.png',
        });
      }, 3000);
    }
  };

  return (
    <div className="bg-white rounded-xl p-4 border border-stone-200 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <Bell className="w-5 h-5 text-brand-500" />
        <h3 className="font-bold text-stone-800">תזכורות יומיות</h3>
      </div>

      {permission === 'denied' ? (
        <div className="bg-red-50 rounded-lg p-3 text-sm text-red-700">
          <BellOff className="w-4 h-4 inline ml-1" />
          התראות חסומות - אפשר אותן בהגדרות הדפדפן
        </div>
      ) : permission !== 'granted' ? (
        <button
          onClick={requestPermission}
          className="w-full bg-brand-500 text-white py-3 rounded-xl font-bold hover:bg-brand-600 transition flex items-center justify-center gap-2"
        >
          <Bell className="w-5 h-5" />
          הפעל תזכורות יומיות
        </button>
      ) : (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-stone-700">הפעל תזכורות</span>
            <button
              onClick={() => setEnabled(!enabled)}
              className={`w-12 h-6 rounded-full transition-all flex items-center px-1 ${
                enabled ? 'bg-brand-500' : 'bg-stone-300'
              }`}
            >
              <div className={`w-4 h-4 bg-white rounded-full shadow transition-all ${enabled ? 'translate-x-6' : ''}`} />
            </button>
          </div>

          {enabled && (
            <div>
              <label className="text-sm font-semibold text-stone-700 block mb-2">
                שעת תזכורת יומית
              </label>
              <input
                type="time"
                value={reminderTime}
                onChange={e => setReminderTime(e.target.value)}
                className="w-full px-3 py-2 border border-stone-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-400"
              />
            </div>
          )}

          <button
            onClick={saveSettings}
            className={`w-full py-2 rounded-xl font-bold transition flex items-center justify-center gap-2 ${
              saved ? 'bg-brand-500 text-white' : 'bg-brand-500 text-white hover:bg-brand-600'
            }`}
          >
            {saved ? <><Check className="w-4 h-4" /> נשמר!</> : 'שמור הגדרות'}
          </button>

          <div className="bg-brand-50 rounded-lg p-3">
            <p className="text-xs font-semibold text-brand-800 mb-2">💬 דוגמאות לתזכורות:</p>
            <ul className="text-xs text-brand-700 space-y-1">
              {MOTIVATIONAL.slice(0, 3).map((q, i) => (
                <li key={i}>• {q}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
